import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=6864287c&scoped=true&"
import script from "./ProcessForm.vue?vue&type=script&lang=js&"
export * from "./ProcessForm.vue?vue&type=script&lang=js&"
import style0 from "./ProcessForm.vue?vue&type=style&index=0&id=6864287c&lang=scss&scoped=true&"
import style1 from "./ProcessForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864287c",
  null
  
)

export default component.exports